import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import PhotographyGrid from "../Components/PhotographyGrid";

const Photos = () => {
    return (
        <div>
            <Navbar />
            <PhotographyGrid />
            <Footer />
        </div>
    );
};

export default Photos;
